import { Dropdown, type DropdownEntry } from "@credit-acceptance/uikit";
import { ChevronDown } from "lucide-react";
import { useTranslation } from "react-i18next";

import { resolveDocumentUrl } from "../../lib/url";

type DocumentLink = { key: string; labelKey: "topBar.fundingPolicies" | "topBar.dscSupportingFAQ"; url: string };

// TopBar dropdown linking out to reference documents, each in a new tab
function HelpMenu() {
  const { t } = useTranslation();

  const fundingManualUrl = resolveDocumentUrl("fundingManual");
  const dscSupportFaqUrl = resolveDocumentUrl("dscSupportFaq");

  const documentLinks: DocumentLink[] = [
    ...(fundingManualUrl
      ? ([
          { key: "funding-manual", labelKey: "topBar.fundingPolicies", url: fundingManualUrl },
        ] satisfies DocumentLink[])
      : []),
    ...(dscSupportFaqUrl
      ? ([
          { key: "dsc-support-faq", labelKey: "topBar.dscSupportingFAQ", url: dscSupportFaqUrl },
        ] satisfies DocumentLink[])
      : []),
  ];

  const items: DropdownEntry[] = documentLinks.map(({ key, labelKey }) => ({
    key,
    label: t(labelKey),
  }));

  const handleClick = ({ key }: { key: string }) => {
    const link = documentLinks.find((candidate) => candidate.key === key);
    if (!link) {
      return;
    }
    globalThis.open(link.url, "_blank", "noopener,noreferrer");
  };

  return (
    <Dropdown items={items} onClick={handleClick} align="end" testId="help-menu" openOnHover>
      <button
        type="button"
        className="text-foreground hover:text-primary flex cursor-pointer items-center gap-1 transition-colors"
      >
        {t("topBar.helpMenu")}
        <ChevronDown aria-hidden="true" className="size-3 shrink-0" />
      </button>
    </Dropdown>
  );
}

export default HelpMenu;
